// arsenal-tpms/frontend/src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import zhCN from './locales/zh-CN.json';
import ja from './locales/ja.json';

// Language detection options
const detection = {
    order: [
        'localStorage', // Check localStorage first (user preference)
        'navigator', // Then browser language
        'htmlTag', // Then html tag
        'path',
        'subdomain'
    ],
    lookupLocalStorage: 'language',
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    cookieOptions: { path: '/', sameSite: 'strict' }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection,
        resources: {
            es: { translation: es },
            en: { translation: en },
            fr: { translation: fr },
            de: { translation: de },
            it: { translation: it },
            pt: { translation: pt },
            ru: { translation: ru },
            'zh-CN': { translation: zhCN },
            ja: { translation: ja }
        },
        fallbackLng: 'es',
        ns: ['translation'],
        defaultNS: 'translation',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            wait: true,
            bindI18n: 'languageChanged',
            bindI18nStore: false,
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
        },
        load: 'languageOnly',
        cleanCode: true,
        supportedLngs: ['es', 'en', 'fr', 'de', 'it', 'pt', 'ru', 'zh-CN', 'ja'],
        nonExplicitSupportedLngs: true
    });

export default i18n;